export default {
  path: 'candidates',
  name: 'Candidates',
};
